import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title = "PrintAura - Premium Mono-Carton Packaging Solutions",
  description = "PrintAura specializes in premium mono-carton packaging, custom boxes, and sustainable printing solutions for luxury brands.",
  keywords = "packaging, mono-cartons, custom boxes, printing, premium packaging, sustainable packaging, PrintAura",
  image = "/Images/hero_pa.webp",
  url = "https://printaura.co.in",
  type = "website"
}) => {
  const siteTitle = title.includes("PrintAura") ? title : `${title} | PrintAura`;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};
